<template>
  <div class="v2_info-popup__body px-0">
    <p v-if="isFirstRender && content && content.p1">{{ content.p1 }}</p>
    <div v-if="!isFirstRender" class="v2_info-popup__body d-flex flex-column align-items-center">
      <p>
        These symbols are used to indicate your progress on the study:
      </p>
      <ul>
        <li>
          <span class="question-link completed" />
          = Completed Question
        </li>
        <li>
          <span class="question-link declined" />
          = Declined Question
        </li>
        <li>
          <span class="question-link invalid" />
          = Question with Invalid Response
        </li>
        <li>
          <span class="question-link" />
          = Uncompleted Question
        </li>
      </ul>
    </div>
    <p>
      <span v-if="content && content.p2">{{ content.p2 }}</span>
      <span v-else>
        You may review all of your answers before submitting the Study.
      </span>
    </p>
    <p>Click “Close” to get started and submit your responses.</p>
  </div>
</template>

<script>
export default {
  name: 'HelpPopup',
  props: {
    content: {
      validator: (prop) => typeof prop === 'object' || prop === null,
      default: null,
    },
    isFirstRender: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    user: function () {
      return this.$store.state.user;
    },
    specialty: function () {
      const specialty = this.user.society.specialties.find(
        (s) => s.id === this.user.specialty_id
      );
      return specialty ? specialty.title : '';
    },
    faqUrl: function () {
      return `${window.location.origin}/#/help`;
    },
  },
};
</script>

<style scoped lang="scss">
@import '../../../../sass/variables_mixins';

.v2_info-popup__body {
  padding: 0 20px;

  ul {
    list-style-type: none;
    padding: 0;
  }
}

.question-link {
  position: relative;
  display: inline-block;
  margin: 0;
  width: 15px;
  height: 15px;
  line-height: 15px;
  cursor: pointer;
  background-color: #e3e3e3;

  &:hover {
    background-color: #aaa;
  }

  &.current,
  &.current:hover {
    background-color: #777;
  }

  &.completed {
    background-color: $phairify_secondary_color_lime;

    &:hover {
      background-color: darken($phairify_secondary_color_lime, 12%);
    }

    &.current {
      background-color: darken($phairify_secondary_color_lime, 20%);
    }
  }

  &.invalid {
    background-color: $light-red;

    &:hover {
      background-color: darken($light-red, 15%);
    }

    &.current {
      background-color: darken($light-red, 25%);
    }
  }

  &.declined {
    background-color: $yellow;

    &:hover {
      background-color: darken($yellow, 15%);
    }

    &.current {
      background-color: darken($yellow, 25%);
    }
  }
}
</style>
